import { Tabs } from 'app/components/tabs';
import { useTranslation } from 'react-i18next';
import type { Dispatch, SetStateAction } from 'react';
import type { ProfileTab } from './profile-section-types';
import type { useProfileListingsData } from './shared';

export function ProfileSectionTabs({
  isPlace,
  profileTab,
  listings,
  canRateAfterLoans,
  sharingPlacesEnabled,
  ns,
  ratingsCount,
  setProfileTab,
}: {
  isPlace: boolean;
  profileTab: ProfileTab;
  listings: ReturnType<typeof useProfileListingsData>;
  canRateAfterLoans: boolean;
  sharingPlacesEnabled: boolean;
  ns: 'my-profile' | 'neighbour-profile';
  ratingsCount: number;
  setProfileTab: Dispatch<SetStateAction<ProfileTab>>;
}) {
  const { t } = useTranslation();
  return (
    <>
      {!isPlace ? (
        <Tabs
          variant="profile"
          value={profileTab === 'listings' ? listings.neighbourTab : profileTab}
          tabs={[
            { value: 'overview', label: t('tabs.overview', { ns: 'neighbour-profile' }) },
            {
              value: 'offers',
              label: t('tabs.offers', { ns }),
              extraLabel: String(listings.offers.total),
            },
            {
              value: 'requests',
              label: t('tabs.requests', { ns }),
              extraLabel: String(listings.requests.total),
            },
            ...(canRateAfterLoans
              ? [
                  {
                    value: 'reviews',
                    label: t('tabs.reviewsShort', { ns: 'neighbour-profile' }),
                    extraLabel: String(ratingsCount),
                  },
                ]
              : []),
            ...(sharingPlacesEnabled ? [{ value: 'places', label: t('tabs.places', { ns }) }] : []),
          ]}
          onPress={(tab) => {
            if (tab === 'offers' || tab === 'requests') {
              listings.setNeighbourTab(tab);
              setProfileTab('listings');
            } else if (tab === 'overview' || tab === 'reviews' || tab === 'places') {
              setProfileTab(tab);
            }
          }}
        />
      ) : null}
    </>
  );
}
